import { useLanguage } from "@/context/LanguageContext";

const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_abule-imole/artifacts/x2lwzvgp_WhatsApp%20Image%202026-04-17%20at%2000.10.23.jpeg",
  exterior: "https://customer-assets.emergentagent.com/job_abule-imole/artifacts/x2lwzvgp_WhatsApp%20Image%202026-04-17%20at%2000.10.23.jpeg",
};

function BookHero() {
  const { t } = useLanguage();
  return (
    <section data-testid="book-hero" className="relative min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.hero})` }} />
      <div className="absolute inset-0 bg-[#1C2333]/50" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 sm:pt-44 pb-32 flex flex-col items-center text-center">
        <p className="text-base sm:text-lg tracking-[0.2em] uppercase font-semibold text-[#C4883A] mb-6 animate-fade-in-up opacity-0">{t.book.label}</p>
        <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-white max-w-3xl leading-tight animate-fade-in-up opacity-0 animate-delay-100">
          {t.book.heroTitle1}<br /><span className="font-medium">{t.book.heroTitle2}</span>
        </h1>
        <p className="mt-8 text-white/70 text-lg sm:text-xl lg:text-2xl max-w-2xl leading-relaxed animate-fade-in-up opacity-0 animate-delay-200">{t.book.heroBody}</p>
      </div>
    </section>
  );
}

function LodgeSection() {
  const { t } = useLanguage();
  return (
    <section data-testid="bridge-lodge-section" className="py-20 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <p className="text-base sm:text-lg tracking-[0.2em] uppercase font-semibold text-[#C4883A] mb-4">{t.book.accommodationLabel}</p>
            <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-medium tracking-tight text-[#1B3D2F] mb-6">{t.book.lodgeTitle}</h2>
            <p className="text-lg sm:text-xl leading-relaxed text-[#1C2333]/80 mb-6">{t.book.lodgeBody}</p>
            <div className="text-lg sm:text-xl leading-relaxed text-[#1C2333]/80">
              <p className="font-semibold mb-2">{t.book.bookingIntro}</p>
              <p>{t.book.bookingCall} <a href="tel:07063043361" className="text-[#C4883A] hover:underline">07063043361</a></p>
              <p>{t.book.bookingEmail} <a href="mailto:bookings@thebridgelodge.net" className="text-[#C4883A] hover:underline">bookings@thebridgelodge.net</a></p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="overflow-hidden"><img src={IMAGES.exterior} alt="The Bridge Lodge" className="w-full h-64 lg:h-72 object-cover" /></div>
          </div>
        </div>
      </div>
    </section>
  );
}

function BookCta() {
  const { t } = useLanguage();
  return (
    <section data-testid="book-cta" className="bg-[#C8C5BC]/20 py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-medium tracking-tight text-[#1B3D2F] mb-6">{t.book.ctaTitle}</h2>
        <p className="text-lg sm:text-xl leading-relaxed text-[#1C2333]/80 max-w-2xl mx-auto mb-10">{t.book.ctaBody}</p>
        <div className="text-lg sm:text-xl leading-relaxed text-[#1C2333]/80">
          <p className="font-semibold mb-2">{t.book.bookingIntro}</p>
          <p>{t.book.bookingCall} <a href="tel:07063043361" className="text-[#C4883A] hover:underline">07063043361</a></p>
          <p>{t.book.bookingEmail} <a href="mailto:bookings@thebridgelodge.net" className="text-[#C4883A] hover:underline">bookings@thebridgelodge.net</a></p>
        </div>
      </div>
    </section>
  );
}

export default function BookStay() {
  return (
    <div data-testid="book-page">
      <BookHero />
      <LodgeSection />
      <BookCta />
    </div>
  );
}
